import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Mail, Send } from 'lucide-react';
import { toast } from 'sonner';
import { subscribeDigest } from '../lib/api';
import { Input } from './ui/input';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Please enter your email.'); return; }
    setLoading(true);
    try {
      const res = await subscribeDigest({ email, origin_url: window.location.origin });
      toast.success(res.message || 'Subscribed!');
      setEmail('');
    } catch (err) {
      toast.error('Could not subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="border-t border-black/10 mt-24">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
        <div className="bg-white rounded-[24px] p-8 sm:p-10 shadow-[0_25px_70px_-50px_rgba(14,23,38,0.4)] grid md:grid-cols-2 gap-6 items-center mb-14">
          <div>
            <h3 className="font-display font-extrabold text-[#0E1726] text-[24px] sm:text-[28px] tracking-tight">Get the weekly digest.</h3>
            <p className="text-[#5B6472] mt-2 leading-relaxed">Top community discussions and fresh resources, delivered to your inbox. Subscribe and we'll email you this week's edition right away.</p>
          </div>
          <form onSubmit={subscribe} className="flex flex-col sm:flex-row gap-3 md:justify-self-end w-full md:max-w-md">
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="h-12 flex-1" />
            <button type="submit" disabled={loading} data-cta="Subscribe" className="bg-[#2E6BFF] text-white font-semibold px-6 h-12 rounded-full inline-flex items-center justify-center gap-2 hover:bg-[#1f5aef] transition-colors disabled:opacity-60 whitespace-nowrap">
              {loading ? 'Subscribing...' : 'Subscribe'} <Send size={16} />
            </button>
          </form>
        </div>

        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-10">
          <div>
            <div className="font-display text-[19px] font-bold text-[#0E1726]">
              bytesize<span className="text-[#2E6BFF]">PM</span> by Rajni
            </div>
            <p className="text-[#5B6472] mt-3 max-w-xs leading-relaxed">
              Practical product leadership for the next chapter.
            </p>
            <div className="flex gap-3 mt-5">
              {[Linkedin, Twitter, Mail].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full border border-black/10 flex items-center justify-center text-[#0E1726] hover:bg-[#0E1726] hover:text-white transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <div className="eyebrow text-[#5B6472] mb-4">Explore</div>
            <ul className="space-y-2.5 text-[#0E1726]">
              <li><Link to="/programs" className="hover:text-[#2E6BFF]">Programs</Link></li>
              <li><Link to="/community" className="hover:text-[#2E6BFF]">Community</Link></li>
              <li><Link to="/blog" className="hover:text-[#2E6BFF]">Resources</Link></li>
              <li><Link to="/about" className="hover:text-[#2E6BFF]">About Rajni</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow text-[#5B6472] mb-4">Get in touch</div>
            <ul className="space-y-2.5 text-[#0E1726]">
              <li><Link to="/enroll" className="hover:text-[#2E6BFF]">Join the AI cohort</Link></li>
              <li><Link to="/contact" className="hover:text-[#2E6BFF]">Corporate training</Link></li>
              <li><Link to="/contact" className="hover:text-[#2E6BFF]">Speaking requests</Link></li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-between gap-3 mt-12 pt-6 border-t border-black/10 text-[#5B6472] text-sm">
          <span>bytesizePM by Rajni — Practical product leadership for the next chapter.</span>
          <span>© 2026 Rajni Sharma · San Francisco Bay Area</span>
        </div>
      </div>
    </footer>
  );
}
